import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2'; // Import SweetAlert2
import "./Profile.css";
import DashboardLayout from '../Dashboard/layout';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Headings } from '../RegisteredUsersList/ViewRegList';
import { Link } from 'react-router-dom';
import { FaTwitter, FaFacebook, FaInstagram, FaLinkedin, FaEye, FaEyeSlash } from "react-icons/fa";
import { Form } from 'react-bootstrap';
import { FiUpload } from "react-icons/fi";
import { MdDelete } from "react-icons/md";

const Profile = () => {
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [renewPassword, setRenewPassword] = useState('');
  const [profileImage, setProfileImage] = useState('');
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('');
  const [status, setStatus] = useState(1); // Default to active (1)
  const [loading, setLoading] = useState(false); // For loading state
  const [previewImage, setPreviewImage] = useState('');

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showRenewPassword, setShowRenewPassword] = useState(false);
  const togglePasswordVisibility = (setType) => {
    setType((prevState) => !prevState);
  };

  // Fetch profile data on component mount
  useEffect(() => {
    const authUser = localStorage.getItem('authUser');
    const authUserData = JSON.parse(authUser);
    const adminId = authUserData?.admin?.id;
    
    if (adminId) {
      fetchProfileData(adminId);
    }
  }, []);

  // Fetch profile data
  const fetchProfileData = async (adminId) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/admin/loginAdminDetail`, 
        { id: adminId }  // Pass the actual adminId here
      );
      const profileData = response.data;
      console.log(profileData);
      
      if (profileData.status === 1) {
        setProfileImage(profileData.admin.profilePic || "assets/img/profile-img.jpg");
        setFullName(profileData.admin.name || "");
        setEmail(profileData.admin.email || "");
        setRole(profileData.admin.role || "");
        setStatus(profileData.admin.status || 1);
      } else {
        console.error(profileData.errors);
      }
    } catch (error) {
      console.error("Error fetching profile data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitProfileUpdate = async (event) => {
    event.preventDefault();
  
    const authUser = localStorage.getItem('authUser');
    const authUserData = JSON.parse(authUser);
    const adminId = authUserData?.admin?.id;
  
    const formData = new FormData();
    formData.append('name', fullName);
    formData.append('email', email);
    formData.append('role', role);
    formData.append('status', status);
    formData.append('adminId', adminId); 
  
    if (profileImage && profileImage instanceof File) {
      formData.append('profilePic', profileImage);
     // console.log("upadte profilePic respose",profileImage);

    }
    console.log("upadte data",formData);
  
    try {
      setLoading(true);
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}api/admin/updateProfile`,
        formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      

  
      // Check for success status in response
      if (response.data.status === 1) {
        Swal.fire({
          title: 'Success!',
          text: 'Profile updated successfully!',
          icon: 'success',
          confirmButtonText: 'Okay',
        }).then(() => {
          window.location.reload();
        });
      } else {
        Swal.fire({
          title: 'Error!',
          text: response.data.errors?.message || 'Error updating profile. Please try again later.',
          icon: 'error',
          confirmButtonText: 'Try Again',
        });
      }
  
    } catch (error) {
      const errorMessage = error.response?.data?.errors?.message || 'Error updating profile. Please try again later.';
      
      Swal.fire({
        title: 'Error!',
        text: errorMessage,
        icon: 'error',
        confirmButtonText: 'Try Again',
      });
    } finally {
      setLoading(false);
    }
  };
  
  
  
  

  // Handle form submission for password change
  const handleSubmitPasswordChange = async (event) => {
    event.preventDefault();
    const authUser = localStorage.getItem('authUser');
    const authUserData = JSON.parse(authUser);
    const email = authUserData?.admin?.email;
  
    if (!email) {
      // If email doesn't exist, show an error message (optional)
      Swal.fire({
        title: 'Error!',
        text: 'Unable to fetch your email. Please log in again.',
        icon: 'error',
        confirmButtonText: 'Okay'
      });
      return;
    }
  
    if (newPassword === renewPassword) {
      try {
        setLoading(true);
        await axios.post(
          `${process.env.REACT_APP_BASE_URL}api/admin/UpdatePassword`,
          { 
            password, 
            newPassword, 
            renewPassword, 
            email 
          }
        );
        
        Swal.fire({
          title: 'Success!',
          text: 'Password changed successfully!.',
          icon: 'success',
          confirmButtonText: 'Okay'
        }).then(() => {
          window.location.reload();
        });
      } catch (error) {
        Swal.fire({
          title: 'Error!',
          text: 'Error changing password. Please try again.',
          icon: 'error',
          confirmButtonText: 'Try Again'
        });
      } finally {
        setLoading(false);
      }
    } else {
      Swal.fire({
        title: 'Error!',
        text: 'Passwords do not match.',
        icon: 'error',
        confirmButtonText: 'Okay'
      });
    }
  };

 


  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      // Set profile image to file for FormData
       setProfileImage(file);
    }
  };



  // Handle image deletion
  const handleImageDelete = () => {
    setPreviewImage(null); // Reset the preview image
    setProfileImage("https://bootstrapmade.com/content/demo/NiceAdmin/assets/img/profile-img.jpg"); // Reset to default image
  };

  return (
    <DashboardLayout>
      <section className="ProfilePageSec">
        
          <Headings headspan="Profile" hedtext=" " />

          <div className="profileData">

            <div className="ProfileCard">
              <img src={profileImage} alt="Profile" />
              <div className="proftext">
                <h4>{fullName || 'Kevin Anderson'}</h4>
                <h6>{role || 'SuperAdmin'}</h6>
              </div>
              <div className="social_links">
                <Link to="#"><FaTwitter /></Link>
                <Link to="#"><FaFacebook /></Link>
                <Link to="#"><FaInstagram /></Link>
                <Link to="#"><FaLinkedin /></Link>
              </div>
            </div>

            <div className="ProfileTabs">
              <Tabs defaultActiveKey="overview" id="uncontrolled-tab-example" className="mb-3">
                <Tab eventKey="overview" title="Overview">
                  <div className="ProflTabData">
                    <div className="aboutDiv">
                      <h4>About</h4>
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit fugiat id, illo in quae magni minus illum vel omnis accusamus dolor, molestiae repudiandae maiores rem!</p>
                    </div>
                    <div className="prfdtl">
                      <h4>Profile Details</h4>
                      <div className="DetailsData">
                        <div className="DetailItems">
                          <h6>Full Name</h6>
                          <p>{fullName || 'Kevin Anderson'}</p>
                        </div>
                        <div className="DetailItems">
                          <h6>Email</h6>
                          <p>{email || 'k.anderson@example.com'}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab>

                <Tab eventKey="editProfile" title="Edit Profile">
                  <div className="ProflTabData">
                    <Form onSubmit={handleSubmitProfileUpdate}>
                      <div className="EditDetailsData">
                      <div className="ProfPicDiv">
                          <h4>Profile Image</h4>
                          <div className="prfperview">
                            {previewImage ? (
                              <img src={previewImage} alt="Profile Preview" />
                            ) : (
                              profileImage && <img src={profileImage} alt="Profile" /> 
                            )}
                            <div className="Proficon">
                              <div className="profupld">
                                <input type="file" id="profileImage" onChange={handleImageUpload} />
                                <span><FiUpload /></span>
                              </div>
                              <div className="delteicon" onClick={handleImageDelete}>
                                <span><MdDelete /></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="FormGroupDiv">
                          <label>Full Name</label>
                          <input
                            name="fullName"
                            type="text"
                            className="form-control"
                            id="fullName"
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                          />
                        </div>
                        <div className="FormGroupDiv">
                          <label>Email</label>
                          <input
                            name="email"
                            type="email"
                            className="form-control"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                        <div className="FormGroupDiv">
                          <label>Status</label>
                          <select
                            name="status"
                            className="form-control"
                            id="status"
                            value={status}
                            onChange={(e) => setStatus(Number(e.target.value))}>
                            <option value={1}>Active</option>
                            <option value={0}>Inactive</option>
                          </select>
                        </div>
                        <div className="SubMit">
                          <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? 'Saving...' : 'Save Changes'}
                          </button>
                        </div>
                      </div>
                    </Form>
                  </div>
                </Tab>

                <Tab eventKey="changePassword" title="Change Password">
                  <div className="ProflTabData">
                    <Form onSubmit={handleSubmitPasswordChange}>
                      <div className="EditDetailsData">
                        <div className="FormGroupDiv">
                          <label>Current Password</label>
                          <div className="password_wrapper">
                            <input type={showCurrentPassword ? "text" : "password"}
                              name="password"
                              id="currentPassword"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              required/> 
                            <span className="toggle_icon"
                              onClick={() => togglePasswordVisibility(setShowCurrentPassword)}>
                              {showCurrentPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                          </div>
                        </div>
                        <div className="FormGroupDiv">
                          <label>New Password</label>
                          <div className="password_wrapper">
                            <input type={showNewPassword ? "text" : "password"}
                              name="password"
                              id="newPassword"
                              value={newPassword}
                              onChange={(e) => setNewPassword(e.target.value)}
                              required/> 
                            <span className="toggle_icon"
                              onClick={() => togglePasswordVisibility(setShowNewPassword)}>
                              {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                          </div>
                        </div>
                        <div className="FormGroupDiv">
                          <label>Re-enter New Password</label>
                          <div className="password_wrapper">
                            <input type={showRenewPassword ? "text" : "password"}
                              name="password"
                              id="renewPassword"
                              value={renewPassword}
                              onChange={(e) => setRenewPassword(e.target.value)}
                              required/> 
                            <span className="toggle_icon"
                              onClick={() => togglePasswordVisibility(setShowRenewPassword)}>
                              {showRenewPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                          </div>
                        </div>
                        <div className="SubMit">
                          <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? 'Changing...' : 'Change Password'}
                          </button>
                        </div>
                      </div>
                    </Form>
                  </div>
                </Tab>

              </Tabs>
            </div>
          </div>
      </section>
    </DashboardLayout>
  );
};

export default Profile;
